export const superVisorInitialValues = {
  userEmail: "",
  nom: "",
  prenom: "",
  telephone: "",
  notes:"",
  statusId: 1,
  niveauAccesId: "",
  profileCode: "",
};
